/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { colors } from '@playbookux/playbook-web-core';

const { WHITE, GREEN_2, LINK_COLOR } = colors;

const Container = styled.div`
  margin-left: 45px;
  width: 512px;
`;

const ErrorMessage = styled.p`
  font-size: 18px;
`;

const SelectsContainer = styled.div`
  width: 256px;
`;

const CustomButton = ({ next, ...props }) => (
  <Button
    {...props}
  >
    {props.children}
  </Button>
);

CustomButton.propTypes = {
  children: PropTypes.string.isRequired,
  next: PropTypes.bool,
};

CustomButton.defaultProps = {
  next: false,
};

const BottomButton = styled(CustomButton)`
  &&& {
    width: 130px;
    height: 40px;
    font-size: 16px;
    padding: 0 15px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    background-color: ${(props) => (props.next ? GREEN_2 : WHITE)};
    color: ${(props) => (props.next ? WHITE : LINK_COLOR)};
  }
`;

const ContainerButtons = styled.div`
  padding: 60px 0 0;
`;

const Typography = styled.p`
  &&& {
    margin: 5px 0;
  }
`;

const CategorizingLabel = styled.p`
  &&& {
    color: #000000;
    margin-bottom: -15px;
  }
`;

const ContainerInput = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export {
  Container,
  ErrorMessage,
  SelectsContainer,
  BottomButton,
  ContainerButtons,
  Typography,
  CategorizingLabel,
  ContainerInput,
};
